import { render, staticRenderFns } from "./MaterialClassifyMenu.vue?vue&type=template&id=3250fc49&scoped=true&"
import script from "./MaterialClassifyMenu.vue?vue&type=script&lang=js&"
export * from "./MaterialClassifyMenu.vue?vue&type=script&lang=js&"
import style0 from "./MaterialClassifyMenu.vue?vue&type=style&index=0&id=3250fc49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3250fc49",
  null
  
)

export default component.exports